import { Field } from "formik";
import React, { useState, useContext } from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  pushToParams,
  requestTo,
} from "../../components/action-buttons/ActionButtonGenerator";
import CrudMain from "../../components/crud/CrudMain";
import FormikForm from "../../components/crud/FormikForm";
import Select from "../../components/form-fields/Select";
import TextInput from "../../components/form-fields/TextInput";
import EmailInput from "../../components/form-fields/EmailInput";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import MultiSelect from "../../components/form-fields/MultiSelect";
import { formatListWithParameter } from "../../utils";
import { useTranslation } from "react-i18next"; /* Added Line */
import request from "../../services/request";
import { Accordion, Card } from "react-bootstrap";
import Filters from "../../components/list/Filters";
import Checkbox from "../../components/form-fields/Checkbox";
import { ThemeContext } from '../../../context/ThemeContext';


export default function GroupCompanies() {
  const { changeSpinnerStatus } = useContext(ThemeContext);
  const [showModal, setShowModal] = useState(false);
  const [configData, setConfigData] = useState(null);
  const [refreshList, setRefreshList] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [t, i18n] = useTranslation(); /* Added Line */
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState("filter");
  const [filters, setFilters] = useState([]);
  const [filterConfigData, setFilterConfigData] = useState(null);
  const [companies, setCompanies] = useState([]);

  const validationSchema = yup.object({
    name: yup.string().required("Gerekli alan."),
    kurumTipiId: yup.string().required("Gerekli alan."),
  });

  const arrangeBeforePersist = (values) => {
    let payload = {
      name: values.name,
      ghibSorumluId: values.ghibSorumluId,
      kurumTipiId: values.kurumTipiId,
      isSubsidiary: values.isSubsidiary,
      isCorporateLaw: values.isCorporateLaw,
      isPladis: values.isPladis,
      companyGroupId: values.companyGroupId,
      note: values.note,
      // yurtBilgi: values.yurtBilgi == 1 ? "Yurtiçi": "Yurtdışı",
      id: values.id,
      stId: values.stId || 90,
      companyLawyer: values.companyLawyer
    };
    return payload;
  };

  const adaptDataForUpdate = (data) => {
    let adaptedData = {
      name: data.name,
      ghibSorumluId: data.ghibSorumluId,
      kurumTipiId: data.kurumTipiId,
      isSubsidiary: data.isSubsidiary,
      isCorporateLaw: data.isCorporateLaw,
      isPladis: data.isPladis,
      companyGroupId: data.companyGroupDtoList.map((cG) => cG.id),
      note: data.note,
      // yurtBilgi: data.yurtBilgi == "Yurtiçi" ? 1 : 2 ,
      id: data.id,
      stId: data.stId,
      companyLawyer: data.companyLawyer
    };
    setInitialValues(adaptedData);
  };

  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };

  const onAddButtonClicked = () => {
    setShowModal(true);
    setIsUpdating(false);
    setInitialValues({});
  };

  const onGroupChanged = (groupIds) => {
    getCompanies(groupIds);
  };

  const getCompanies = (companyGroupIds, yurtBilgi) => {
    request({
      url: "company/multi-company",
      method: "POST",
      data: {
        body: {
          companyGroupIds: [companyGroupIds],
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setCompanies(response.body.tableData);
      }
    });
  };

  return (
    <Main>
      <div className={"row"}>
        <div className="col-md-12">
          <Accordion
            className="accordion accordion-rounded-stylish accordion-bordered"
            defaultActiveKey="filter"
          >
            <div className="accordion__item" key={"filter"}>
              <Accordion.Toggle
                as={Card.Text}
                eventKey={"filter"}
                className={`accordion__header ${
                  activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                } accordion__header--primary`}
                onClick={() =>
                  setActiveIndicatorInLeftPosition(
                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                  )
                }
              >
                <span className="accordion__header--icon"></span>
                <span className="accordion__header--text">
                  {t("sozlesmeler.filtreleme")}
                </span>
                <span className="accordion__header--indicator"></span>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey={"filter"}
                className="accordion__body"
              >
                <div className="accordion__body--text">
                  <Filters
                    configPointUrl="company/config"
                    setConfigData={(data) => setFilterConfigData(data)}
                    setRefreshList={setRefreshList}
                    refreshList={refreshList}
                    setFilters={setFilters}
                  >
                    <Field
                      name="stId"
                      label={t("demandList.durum")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={filterConfigData && filterConfigData.durum}
                      oper="EQ"
                    />
                    <Field
                      name="kurumTipiId"
                      label={t("grupCompanies.kurumTipi")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={
                        filterConfigData && filterConfigData.institutionTypes
                      }
                      oper="EQ"
                    />
                    <Field
                      name="companyGroupId"
                      fieldName="id"
                      label={t("davaIcraSavcilik.grup")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={filterConfigData && filterConfigData.groups}
                      onChangeFunc={(opt) => onGroupChanged(opt)}
                      joinEntity="companyGroupEntities"
                      oper="EQ"
                    />
                    <Field
                      name="companyId"
                      fieldName="id"
                      label={t("grupCompanies.sirket")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={
                        companies.length > 0
                          ? companies.map((c) => {
                              return { value: c.id, label: c.name };
                            })
                          : filterConfigData && filterConfigData.companies
                      }
                      oper="EQ"
                    />

                    <Field
                      name="name"
                      label={`${t("grupCompanies.sirket")}`}
                      /*joinEntity="test"*/
                      oper="CONTAINS_CASE_AND_ACCENT_INSENSITIVE"
                      /*type="type1"*/
                      colNumber="3"
                      component={TextInput}
                    />
                  </Filters>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <CrudMain
            onAddButtonClicked={onAddButtonClicked}
            showModal={showModal}
            setShowModal={setShowModal}
            title={t("sidebar.sirketler")}
          >
            <FormikForm
              isUpdating={isUpdating}
              entityId={selectedRow && selectedRow.id}
              entityFetchId="id"
              endPointUrl="company/create"
              fetchPointUrl="company/find"
              editPointUrl="company/update"
              configPointUrl="company/config"
              arrangeBeforePersist={arrangeBeforePersist}
              adaptDataForUpdate={adaptDataForUpdate}
              setConfigData={(data) => setConfigData(data)}
              initialValues={initialValues}
              validationSchema={validationSchema}
              closeModal={() => setShowModal(false)}
              refreshList={() => setRefreshList(!refreshList)}
            >
              <Field
                name="companyGroupId"
                label={t("grupCompanies.grup")}
                colNumber="12"
                component={MultiSelect}
                options={configData && configData.groups}
                // required
              />
              {/* <Field
                                name="yurtBilgi"
                                label={t("grupCompanies.menşei")}
                                colNumber="12"
                                component={Select}
                                options={configData && configData.yurtBilgiList}
                                required
                            /> */}
              <Field
                name="kurumTipiId"
                label={t("grupCompanies.kurumTipi")}
                colNumber="12"
                component={Select}
                options={configData && configData.institutionTypes}
                required
              />
              <Field
                name="name"
                label={t("grupCompanies.sirket")}
                colNumber="12"
                component={TextInput}
                required
              />
              <Field
                name="ghibSorumluId"
                label={t("grupCompanies.ghibSorumlusu")}
                colNumber="12"
                component={Select}
                options={configData && configData.ghibPersons}
              />
              <Field
                name="note"
                label={t("grupCompanies.notlar")}
                colNumber="12"
                component={TextInput}
              />
              <Field
                name="companyLawyer"
                label={t("grupCompanies.ilgiliAvukat")}
                colNumber="12"
                component={EmailInput}
                required
              />                     
              <Field
                label="Türkiye İştirak Şirketi Mi?"
                name="isSubsidiary"
                checkboxText="Evet"
                colNumber="12"      
                value={selectedRow?.isSubsidiary}          
                component={Checkbox}              
              />
              <Field
                label="Şirketler Hukuk Şirketi Mi?"
                name="isCorporateLaw"
                checkboxText="Evet"
                colNumber="12"      
                value={selectedRow?.isCorporateLaw}          
                component={Checkbox}              
              />              
              <Field
                label="Pladis Şirketi Mi?"
                name="isPladis"
                checkboxText="Evet"
                colNumber="12"      
                value={selectedRow?.isPladis}          
                component={Checkbox}              
              />              
            </FormikForm>
          </CrudMain>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName="grup-şirketleri"
            endpoint="company/list"
            keyField="id"
            refreshList={refreshList}
            customBody={{
              filters: filters,
            }}
            columns={[
              {
                dataField: "id",
                text: "ID",
                sort: true,
                headerClasses: "id-header",
              },
              {
                dataField: "ghibSorumluName",
                text: "GHİB CC",
                sort: true,
              },
              {
                dataField: "kurumTipiName",
                text: `${t("demandList.kurumTip")}`,
                sort: true,
              },
              {
                dataField: "companyGroupNames",
                text: `${t("demandList.grup")}`,
                sort: true,
                // formatter: (data) => formatListWithParameter(data, "name"),
              },
              {
                dataField: "name",
                text: `${t("demandList.kurumAdi")}`,
                sort: true,
              },
              {
                dataField: "statusName",
                text: `${t("demandList.durum")}`,
                sort: true,
              },
            ]}
            actionButtonsObject={{
              actions: [
                pushToParams(ABT.EDIT, onUpdateButtonClicked),
                requestTo(ABT.ACTIVE, "company/aktif-pasif"),
                requestTo(ABT.PASSIVE, "company/aktif-pasif"),
                /* requestTo(ABT.DELETE, "company/delete"), */
                pushToParams(ABT.EXCEL_EXPORT, {
                  requestTo: "file/download-excel-company",
                }),
              ],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  );
}
